import React, { useState, useEffect } from 'react';

import {
  Add
} from "@mui/icons-material";
import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  FeatureSource,
  ModelBase,
} from "@models";
import { 
  ASIBaseFeature,
  Background, 
  Feat, 
  UpgradableNumber,
} from "@dndModels";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import EditableLabel from "@components/input/strings/EditableLabel";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import FeatureSourceInput from "@dndComponents/FeatureSourceInput";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function BackgroundEdit({ obj: param_obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<Background>(param_obj instanceof Background ? param_obj : api.applyWorkingOn(new Background()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
 
  return (
    <FeatureSourceInput 
      obj={obj}
      data_type="background"
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: FeatureSource) => {
        if (changed instanceof Background) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
        }
      }}
      onSubmitted={(changed) => {
        if (changed instanceof Background) {
          // Update the feats and asis to be correct
          changed.feats = (api.getDataTypeFromHash<Feat>("feat")).filter(o => changed.feat_ids.includes(o._id));
          
          // const asi_fb = changed.feature_bases.find(o => o.features.filter(o2 => o2.floating_feature instanceof ASIBaseFeature && o2.floating_feature.choices.filter(o3 => o3.asi_features.filter(o4 => o4.amount > 0).length > 0).length > 0).length > 0);
          // if (asi_fb) {
          //   const f = asi_fb.features.find(o2 => o2.floating_feature instanceof ASIBaseFeature && o2.floating_feature.choices.filter(o3 => o3.asi_features.filter(o4 => o4.amount > 0).length > 0).length > 0);
          //   if (f && f.floating_feature instanceof ASIBaseFeature) {
          //     const ff = f.floating_feature;
          //     const choice = ff.choices[0];
          //     const asis = common_util.unique_array(choice.asi_features.flatMap(o => o.options));
          //     changed._ability_scores = asis;
          //   }
          // }
        }
      }}
      extra_menu_options={{"Attributes": 
      <Grid
        container
        spacing={0}
        direction="column"
        size={{
          xs: 12
        }}>
        <Grid>
          <span className="header">
            Formulae
          </span>
          { !disabled &&
            <Tooltip title={`Create New Formula`}>
              <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                onClick={ () => {
                  const new_obj = obj;
                  new_obj.formulae["New Formula"] = new UpgradableNumber();
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}>
                <Add/>
              </Fab>
            </Tooltip>
          }
        </Grid>
        { reloading ? 
          <Grid>Reloading</Grid> 
        : Object.keys(obj.formulae).sort((a, b) => {
          return a.localeCompare(b);
        }).map((formula_key, key) => {
          return (
            <Grid key={key} container spacing={0} direction="row">
              <Grid
                size={{
                  xs: 2
                }}>
                <EditableLabel 
                  name="Formula Key"
                  value={formula_key}
                  onChange={(changed: string) => {
                    const new_obj = obj;
                    const old_value = new_obj.formulae[formula_key].clone();
                    delete new_obj.formulae[formula_key];
                    new_obj.formulae[changed] = old_value;
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 10
                }}>
                <UpgradableNumberBox 
                  value={ obj.formulae[formula_key] as UpgradableNumber } 
                  name={ formula_key }
                  disabled={disabled}
                  onChange={(changed: UpgradableNumber) => {
                    const new_obj = obj;
                    new_obj.formulae[formula_key] = changed;
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                  }}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      }}
    />
  ); 
}
